class SurveysProfiler {
    id;
    name;
    lastQuestionAnswered;
    questions;
    createdAt;
    updatedAt;
    constructor(data) {
        this.id = data.id;
        this.name = data.name;
        this.lastQuestionAnswered = data.lastQuestionAnswered;
        this.questions = data.questions;
        this.createdAt = data.createdAt;
        this.updatedAt = data.updatedAt;
    }
}
export default SurveysProfiler;
